/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionRegionEnum = 'EMEA' | 'LATAM' | 'APAC' | 'NA' | 'GLOBAL';

export const SubscriptionRegionEnum = {

    EMEA: 'EMEA' as SubscriptionRegionEnum,

    LATAM: 'LATAM' as SubscriptionRegionEnum,

    APAC: 'APAC' as SubscriptionRegionEnum,

    NA: 'NA' as SubscriptionRegionEnum,

    GLOBAL: 'GLOBAL' as SubscriptionRegionEnum
};

